import React from 'react';
import { FiAlertCircle, FiCheck, FiClock } from 'react-icons/fi';
import Modal from './Modal';
import useGlobalCheckInPrompt from './useGlobalCheckInPrompt';
import { getTimeRangeLabel } from '../dashboard/activeAttendanceSessionsHelpers';
import styles from './GlobalCheckInPrompt.module.css';

function GlobalCheckInPrompt() {
  const { session, open, checkingIn, error, dismiss, checkIn } = useGlobalCheckInPrompt();

  if (!session) return null;

  const modalTitle = (
    <span className={styles.modalTitle}>
      <FiClock size={18} />
      Check-In Reminder
    </span>
  );

  const courseLabel = session.entity_type === 'elective'
    ? `${session.elective_code || ''} · ${session.elective_name || ''}`
    : `${session.course_code || ''} · ${session.course_name || ''}`;

  return (
    <Modal
      open={open}
      onClose={dismiss}
      title={modalTitle}
      maxWidth="440px"
      borderRadius="var(--card-radius)"
      mobileFullScreen={false}
    >
      <div className={styles.body}>
        <div className={styles.courseName}>{courseLabel}</div>
        <div className={styles.windowLine}>Check-in window: {getTimeRangeLabel(session)}</div>
        <p className={styles.message}>You haven't checked in yet.</p>

        {error && (
          <div className={styles.errorRow}>
            <FiAlertCircle size={16} />
            {error}
          </div>
        )}

        <div className={styles.actions}>
          <button
            type="button"
            onClick={checkIn}
            disabled={checkingIn}
            className={styles.checkInButton}
          >
            <FiCheck size={16} />
            {checkingIn ? 'Checking in...' : 'Check In Now'}
          </button>
          <button
            type="button"
            onClick={dismiss}
            disabled={checkingIn}
            className={styles.laterButton}
          >
            Remind Me Later
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default GlobalCheckInPrompt;
